import office, { SurroundingMode } from 'src/services/office';

import { startExecutingFlowstep } from 'src/api';

import { Runnable } from 'src/services/runtime/runnable';

import { SequentialTasksExecutor } from 'src/services/sequentialTasksExecutor';
import { isPullKind, toDisplayName, NoDataError, PullMode } from 'shared/utils/flowstep';
import { parseCellAddress } from 'shared/excel/excel';
import { Data } from 'src/services/flowstepExecution';


export class Flowstep extends Runnable {
  constructor(flowstep, meta, parent = null) {
    super(meta, parent);
    
    this.worksheet = this.context.workbook.worksheets.getItem(flowstep.worksheetId);
    this.flowstep = flowstep;

    this.rowToProcessCount = 0;
    this.processedRowCount = 0;

    this.receivedResultHeaders = null;
    this.resultErrorRange = null;
    this.resultSuccessRange = null;
    this.resultErrors = [];
    
    this.limits = office.platformLimits;
    this.tasks = new SequentialTasksExecutor();
  }

  get name() { return this.flowstep.name; }
  get type() { return this.flowstep.type; }
  get isPull() { return isPullKind(this.type); }
  
  async _run_() {
    try {
      return await office.runWithoutWorksheetProtection(async () => {
        await this.detectTargetTable();
        const result = await this._runFlowstep_();
        return result;
      }, { worksheet: this.worksheet, password: this.flowstep.options.protectionPassword });
    }
    catch (error) {
      if (error instanceof NoDataError) {
        return { warnings: [error] };
      }
      throw error;
    }
    finally {
      // this.resultErrorRange?.track();
      // this.resultSuccessRange?.track();
      await this.tasks.waitForAll();
    }
  }

  async _createLogger_() {
    const ws = this.worksheet.load(['id', 'name']);
    await this.sync();
    
    const { name, type } = this.flowstep;
    const props = { 
      worksheetName: ws.name,
      name:  `Flow step '${name || toDisplayName(type)}'`,
      borderFormat: Data.BorderFormat,
    };

    super.createLogger(props);
  }

  async detectTargetTable() {
    const { target, options } = this.flowstep;
    const range = this.worksheet.getRange(target);
    const alternativeRange = this.isPull ? range : null;

    let surroundingMode = SurroundingMode.default;
    if (this.isPull) {
      if (options.pullMode === PullMode.Append || !options.createDataTable) {
        surroundingMode = SurroundingMode.tableStart;
      }
      else {
        surroundingMode = SurroundingMode.disabled
      }
    }

    this.dataTable = await office.getDataTable(range, { alternativeRange, surroundingMode });
    if (!this.dataTable) {
      throw new NoDataError();
    }

    const { columnIndex } = parseCellAddress(target);
    this.targetColumnOffset = columnIndex - this.dataTable.columnIndex;
  }

  async setTimestampCellValue(ts) {
    const { lastUpdateTimestampCell, lastUpdateTimestampCellAddress } = this.flowstep.options;
    if (!lastUpdateTimestampCell && !lastUpdateTimestampCellAddress) {
      return;
    }
    
    await super.setTimestampCellValue({
      address: lastUpdateTimestampCell,
      worksheetInstance: this.worksheet,
      ...lastUpdateTimestampCellAddress
    }, ts);
  }

  async startRemoteExecution(params) {
    const request = { flowstep: { type: this.flowstep.type, ...params }};
    return await startExecutingFlowstep(request, this.userStoreToken, this.cancelToken);
  }

}


export default Flowstep;